<div class="ml-2 flex h-16 flex-row">
  <div
    *ngIf="!!fractionControl.label"
    class="text-s1 mr-5 flex h-9 flex-shrink-0 select-none items-center text-base"
    >{{ fractionControl.label }}</div
  >

  <form [formGroup]="fractionForm" class="flex flex-col">
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <div
        tp="The value can be set using the metrics time filter (at the top of this page)"
        [tpIsEnabled]="fractionControl.isMetricsDate === true"
      >
        <fieldset
          [disabled]="
            isDisabled === true || fractionControl.isMetricsDate === true
          "
        >
          <ng-select
            *ngIf="!!suggestModelDimension"
            #inputValueSelect
            [fixNgSelectBottom]="inputValueSelect"
            data-cy="inputValueSelect"
            class="w-96 text-base"
            [ngClass]="{
              'cursor-default':
                isDisabled === true || fractionControl.isMetricsDate === true
            }"
            [items]="items"
            [typeahead]="searchInput$"
            [loading]="loading"
            [clearable]="false"
            [searchable]="true"
            (keyup.esc)="
              $event.stopImmediatePropagation(); inputValueSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation(); inputValueSelect.blur()
            "
            (change)="inputValueChange($event)"
            (search)="inputValueSearch($event)"
            (open)="onOpenSelect()"
            (close)="onCloseSelect()"
            appendTo="body"
            bindLabel="name"
            bindValue="name"
            formControlName="inputValue"
          >
            <ng-template ng-option-tmp let-item="item">
              <div
                class="truncate"
                [tp]="item.errorMessage"
                [tpIsEnabled]="!!item.errorMessage"
                >{{ item.name }}</div
              >
            </ng-template>
          </ng-select>

          <input
            *ngIf="!suggestModelDimension"
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionInputValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-[150px] rounded"
            [ngClass]="{
              'border-r600':
                fractionForm.controls['inputValue'].invalid &&
                fractionForm.controls['inputValue'].touched
            }"
            formControlName="inputValue"
            (blur)="inputValueBlur()"
          />
        </fieldset>
      </div>
    </div>

    <m-validation
      [control]="fractionForm.controls['inputValue']"
    ></m-validation>
  </form>
</div>
